import { AnySourceStream, AnySubscription, Stream } from '../stream'
import { Pass } from './pass'

export class Buffer<V = any, E = any, C = any> extends Pass<V, E, C, V[]> {
    protected bufferQueue: V[] = []
    protected toFinish = false
    protected toComplete = false
    protected toError = false
    protected completeEvent: C | undefined
    protected errorEvent: E | undefined

    protected signal: Stream

    protected signalSubscription: AnySubscription = {
        value: () => {
            this.flush()
        },
        complete: () => {
            this.flush()
            this.close()
        },
        error: () => {
            this.flush()
            this.close()
        },
    }

    constructor(signal: Stream, source?: AnySourceStream<V, E, C>) {
        super(source)
        this.signal = signal
    }

    value(value: V) {
        if (this.toFinish) return
        this.bufferQueue.push(value)
    }

    error(error: E) {
        if (this.toFinish) return
        this.toFinish = true
        this.toError = true
        this.errorEvent = error
    }

    complete(complete: C) {
        if (this.toFinish) return
        this.toFinish = true
        this.toComplete = true
        this.completeEvent = complete
    }

    flush() {
        this._value(this.bufferQueue)

        if (this.toComplete) {
            this._complete(this.completeEvent!)
        } else if (this.toError) {
            this._error(this.errorEvent!)
        }

        this.bufferQueue = []
    }

    connect() {
        super.connect()
        this.signal.subscribe(this.signalSubscription)
    }

    disconnect() {
        super.disconnect()
        this.signal.unsubscribe(this.signalSubscription)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        buffer(signal: Stream): Stream<DV, DE, DC, DV[], DE, DC>
    }
}

Stream.prototype.buffer = function <DV, DE, DC>(this: AnySourceStream<DV, DE, DC>, signal: Stream) {
    return new Buffer(signal, this) // tslint:disable-line:no-invalid-this
}
